import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Typography, IconButton } from '@material-ui/core'
import { useUtils } from '@material-ui/pickers'
import { getLocale } from 'app/translations/intl-context'

const useStyles = makeStyles((theme) => ({
  toolbar: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    padding: theme.spacing(2),
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
  },
  yearButton: {
    color: theme.palette.primary.contrastText,
    padding: 0,
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  dateText: {
    cursor: 'pointer',
    '&:hover': {
      opacity: 0.8,
    },
  },
}))

export default function LocalizedDatePickerToolbar({
  date,
  openView,
  setOpenView,
}) {
  const classes = useStyles()
  const utils = useUtils()

  const handleYearClick = () => {
    setOpenView('year')
  }

  const handleDateClick = () => {
    setOpenView('date')
  }

  const formats = {
    th: 'EEEE, d MMMM',
    ru: 'EEEE, d MMMM',
    es: 'EEEE, d MMMM',
    en: 'EEEE, MMMM d',
  }

  const locale = getLocale()
  const dateFormat = formats[locale] || formats.en

  return (
    <div className={classes.toolbar}>
      <IconButton className={classes.yearButton} onClick={handleYearClick}>
        <Typography
          variant="body2"
          style={{ opacity: openView === 'year' ? 1 : 0.7 }}
        >
          {date ? utils.format(date, 'yyyy') : '----'}
        </Typography>
      </IconButton>

      <Typography
        variant="h5"
        className={classes.dateText}
        onClick={handleDateClick}
        style={{ opacity: openView === 'date' ? 1 : 0.7 }}
      >
        {date ? utils.format(date, dateFormat) : 'Select date'}
      </Typography>
    </div>
  )
}
